import React, { useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Popover, message, Form, Select } from "antd";
import { authSVC } from "../../../services";
import type { ColumnsType } from "antd/es/table";

import { CheckOutlined, CheckCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppModal, AppTable } from "../../common";

interface Contentdata {
  demoRequestApproved: any;
  key?: string;
  _id: string;
  bodyText: string;
  user_id: string;
  video_id: string;
  business_name: string;
  business_email: string;
}

function DemoUserTable({ contentData }: any) {
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disabledButtons, setDisabledButtons] = useState<any>({});
  const [recordId, setRecordId] = useState<any>();
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const ConfirmClient = (record: any) => {
    setRecordId(record._id);
    setDisabledButtons((prevState: any) => ({
      ...prevState,
      [record._id]: true,
    }));
    console.log(record,"recordrecord");
    
    authSVC
      .addHruser({
        full_name: record.name,
        email: record.business_email,
        username: record.business_email,
        company: record.business_name,
        user_type: "Company_admin",
        phone_number: record.phone_number,
      })
      .then((res: any) => {
        if (res.data?.success === false) {
          message.error(res.data?.error || res.data?.message || "Failed to create company admin");
          setDisabledButtons((prevState: any) => ({
            ...prevState,
            [record._id]: false,
          }));
          return;
        }
        message.success("Added User Successfully");
        setIsModalOpen(false);
        window.location.reload();
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error || err.response?.data?.message || "Failed to create company admin");
        setDisabledButtons((prevState: any) => ({
          ...prevState,
          [record._id]: false,
        }));

        // if (contentData.find((source: any) => source._id === record._id)) {
        //   setBtnDisable(true);
        // }

        // setloading(false);
      });
  };

  const shouldDisableButton = (key: any) => {
    // alert();
    // Replace this with your condition to disable the button based on the key
    // For example, disable the button if the key is '2'

    return key === recordId;
  };

  const onFinish = (values: any) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo: any) => {};

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const renderActions = (record: any) => (
    <div>
      <p className="disc">
        After selecting Confirm Client, the client will be added to your list.
        Navigate to Client Management → Clients, assign the appropriate package,
        and then share the payment link to finalize the process.
      </p>
      <Button
        onClick={() => ConfirmClient(record)}
        className="confirm"
        disabled={!!disabledButtons[record._id]}
      >
        Confirm Client
      </Button>
    </div>
  );

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 120,
      filteredValue: [searchText],
      render: (text) => <div className="truncate">{text}</div>,
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      onFilter: (value, record) => {
        return (
          String(record.business_email)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record.business_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record._id).toLowerCase().includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 120, // Set a fixed wid
      key: "name",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Company Name",
      dataIndex: "business_name",
      width: 140, // Set a fixed wid
      key: "business_name",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Company Email",
      dataIndex: "business_email",
      key: "business_email",
      width: 210, // Set a fixed wid
      sortDirections: ["descend"],
      render: (text) => <div>{text}</div>,
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 160,
      render: (text) => <div>+{text}</div>,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 160,
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Action",
      key: "action",
      // width: 160,
      render: (_, record) =>
        !record.demoRequestApproved ? (
          <Space size="middle">
            <Popover
              content={renderActions(record)}
              title="Actions"
              trigger="hover"
              className="table_pop_over"
            >
              <button
                disabled={disabledButtons[record._id]}
                className="tbl-action-btn tbl-action-btn--confirm"
              >
                <CheckOutlined />
                Confirm
              </button>
            </Popover>
          </Space>
        ) : (
          <button disabled={true} className="tbl-action-btn tbl-action-btn--confirm">
            <CheckCircleOutlined />
            Confirmed
          </button>
        ),
    },
  ];
  const handleChange = (value: string) => {
    console.log(`selected ${value}`);
    // setCompanySize(value);
  };

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
      <AppModal
        title="Assign Package"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="checkout_popup"
      >
        <>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              label="Package Name"
              name="package_name"
              rules={[
                { required: true, message: "Please input your username!" },
              ]}
            >
              <Select
                onChange={handleChange}
                options={[
                  { value: "Gold", label: "Gold" },
                  { value: "Diamond", label: "Diamond" },
                  { value: "Platinum", label: "Platinum" },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Package Price"
              name="package_price"
              rules={[
                { required: true, message: "Please input your username!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </>
      </AppModal>
    </div>
  );
}

export default DemoUserTable;
